module.exports = __webpack_public_path__ + "static/media/icon_menu_active.2ae1b8cf.svg";